export const makeData = (clients) =>
  clients.map((client) => ({
    accountName: client.Account_Name,
    sem: client.SEM,
    social: client.Social,
    ott: client.OTT,
    total: client.SEM_Total_Budget,
    isActive: client.Rating,
  }));
export const makeData2 = (clients) =>
  clients.map((client) => ({
    accountName: client.Account_Name,
    sem: client.SEM,
    semSplitNew: client.SEM_New,
    semSplitUsed: client.SEM_Used,
    semNew: client.SEM_New1,
    semUsed: client.SEM_Used1,
    spanishSEM: client.Spanish_Search,
    spanishSplitNew: client.Spanish_Split_New,
    spanishSplitUsed: client.Spanish_Split_Used,
    spanishNew: client.Spanish_SEM_New,
    spanishUsed: client.Spanish_SEM_Used,
    semBrSplit: client.SEM_B_R1,
    semSpanishBrSplit: client.Spanish_SEM_B_R1,
    semBr: client.SEM_B_R,
    semSpanishBr: client.Spanish_SEM_B_R,
    vla: client.VLA,
    vlaSplitNew: client.VLA_Split_New,
    vlaSplitUsed: client.VLA_Split_Used,
    vlaNew: client.VLA_New,
    vlaUsed: client.VLA_Used,
    fixedOpsSearch: client.Fixed_Ops_Search,
    searchTotal:
      client.SEM +
      client.VLA +
      client.Fixed_Ops_Search +
      client.Spanish_Search +
      client.SEM_B_R,
  }));
export const makeData3 = (clients) =>
  clients.map((client) => ({
    accountName: client.Account_Name,
    social: client.Social,
    socialSplitNew: client.Social_Split_New,
    socialSplitUsed: client.Social_Split_Used,
    socialNew: client.Social_New,
    socialUsed: client.Social_Used,
    spanishSocial: client.Spanish_Social,
    spanishSocialSplitNew: client.Social_Spanish_Split_New,
    spanishSocialSplitUsed: client.Social_Spanish_Split_Used,
    spanishSocialNew: client.Social_Spanish_New,
    spanishSocialUsed: client.Social_Spanish_Used,
    fixedOpsSocial: client.Fixed_Ops_Social,
    socialTotal:
      client.Social + client.Fixed_Ops_Social + client.Spanish_Social,
  }));
export const clientData = (clients) =>
  clients.map((client) => ({
    accountName: client.label,
    brand: client.brand,
    clienetwebsite: client.clientwebsite,
    status: client.status === true ? "Active" : "Inactive",
    tasks: client.monthlyTasklistStatus,
  }));
